import { useEffect, useState } from "react";
import { Forward, Loader2, Search, X } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../../connect/api";
import { Avatar, roleLine } from "./ui";

/** CEO only: forward a message to any staff member (opens/reuses the direct conversation). */
export const ForwardSheet = ({ message, fromName, onClose }) => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get("/directory", { params: { view: "all", q, limit: 25 } }).then((r) => setItems(r.data.items || [])).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  const send = async (s) => {
    setBusy(s.id);
    try {
      const { data: conv } = await api.post("/conversations", { staff_id: s.id });
      const att = message.attachment ? `\n📎 ${message.attachment.name || "Attachment"}${message.attachment.url ? ` — ${window.location.origin}${message.attachment.url}` : ""}` : "";
      await api.post(`/conversations/${conv.id}/messages`, { text: `↪ Forwarded message from ${fromName}:\n${message.text || ""}${att}`.trim() });
      toast.success(`Forwarded to ${s.name}`);
      onClose();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(""); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-end sm:items-center justify-center" onClick={onClose} data-testid="forward-sheet">
      <div className="w-full max-w-md bg-[#0e1626] border border-white/10 rounded-t-3xl sm:rounded-3xl max-h-[80vh] flex flex-col nxc-fade-in" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 p-3 border-b border-white/10">
          <Forward size={16} className="text-amber-300" /><span className="font-semibold text-slate-100 flex-1">Forward to…</span>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white/10" data-testid="forward-close"><X size={16} /></button>
        </div>
        <div className="p-3 text-xs text-slate-400 border-b border-white/5 line-clamp-2">“{message.text || message.attachment?.name}”</div>
        <div className="p-3"><div className="relative"><Search size={14} className="absolute left-3 top-3 text-slate-500" /><input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search staff by name" className="nxc-input pl-9" data-testid="forward-search-input" /></div></div>
        <ul className="overflow-y-auto px-2 pb-3 space-y-1">
          {items.map((s) => (
            <li key={s.id}>
              <button onClick={() => send(s)} disabled={!!busy} className="w-full flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 text-left" data-testid={`forward-to-${s.id}`}>
                <Avatar name={s.name} src={s.avatar} size={34} ceo={s.is_ceo} />
                <span className="flex-1 min-w-0"><span className="block text-sm text-slate-100 truncate">{s.name}</span><span className="block text-[11px] text-slate-400 truncate">{roleLine(s, true)}</span></span>
                {busy === s.id ? <Loader2 size={14} className="animate-spin" /> : <Forward size={14} className="text-slate-500" />}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
